import * as z from "zod/v4";

export const saveAccountingConnectionSettings = {
  name: "saveAccountingConnectionSettings" as const,
  input: z.object({
    syncPurchaseOrders: z.boolean(),
    syncItems: z.boolean(),
    costMethod: z.enum(["fifo", "weighted_average"]),
  }),
  output: z.object({ success: z.boolean() }),
};
